import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import BASE_URL from "../../../baseUrl";
import ListingCard from "../../shared/ListingCard";

const Toplistings = () => {
  const customeSlider = useRef();
  const { t } = useTranslation();

  const [listing, setListing] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  const SubmitlistingData = async () => {
    // const response = await fetch(`${BASE_URL}/submitlisting/lastsubmit`);
    const response = await fetch(`${BASE_URL}/admin/topList`);
    const data = await response.json();
    console.log(data.result);
    setListing(data.result);
  };

  useEffect(() => {
    SubmitlistingData();
  }, []);

  const next = () => {
    if (customeSlider.current) {
      customeSlider.current.slickNext();
    }
  };

  const previous = () => {
    if (customeSlider.current) {
      customeSlider.current.slickPrev();
    }
  };

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentSlide(newIndex);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: false,
        },
      },
    ],
  };

  return (
    <div className="section sectionlisting">
      <div className="container top-listings">
        <div className="acr-arrows" style={{ left: "40px", bottom: "-40px" }}>
          <button
            className="slider-prev fas fa-arrow-left slick-arrow"
            onClick={previous}
            disabled={currentSlide === 0}
          />
          <button
            className="slider-next fas fa-arrow-right slick-arrow"
            onClick={next}
            disabled={currentSlide >= listing.length - slidesToShow}
          />
        </div>
        <div className="section-title-wrap section-header">
          <h5 className="custom-primary">{t("trending")}</h5>
          <h2 className="title">{t("ourTopListings")}</h2>
        </div>
        <Slider
          className="top-listings-slider"
          ref={customeSlider}
          {...settings}
        >
          {listing.length == 0 ? (
            <p className="text-center my-4 text-xl font-medium">
              {t("No top list available")}
            </p>
          ) : (
            listing?.map((item, i) => (
              <ListingCard key={i} listing={item} t={t} />
            ))
          )}
        </Slider>
      </div>
    </div>
  );
};

export default Toplistings;
